import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, ownerOnly = false }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="p-10 font-mono text-xs uppercase tracking-widest text-slate-500">Loading…</div>;
  if (!user) return <Navigate to={`/auth?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (ownerOnly && !user.superadmin) return <Navigate to="/dashboard" replace />;
  return children;
};
